import { api } from "@contexts";
import { PDFData } from "@interfaces";
import {
  ErrorType,
  onDocumentSignatureAxiosErrorInterpreter,
} from "./onDocumentSignatureError";

export interface SignCompoundPrescriptionDocumentParams {
  requestId: string;
  managementSummary: string;
  pin: string;
}

interface SignCompoundPrescriptionDocumentResponse extends PDFData {}

export async function signCompoundPrescriptionDocument({
  requestId,
  managementSummary,
  pin,
}: SignCompoundPrescriptionDocumentParams): Promise<[string, PDFData[]]> {
  const response = await api<
    SignCompoundPrescriptionDocumentResponse,
    ErrorType
  >(
    {
      method: "post",
      url: `/requests/${requestId}/compounded-prescriptions/sign`,
      data: {
        managementSummary,
        pin,
      },
    },
    onDocumentSignatureAxiosErrorInterpreter
  );
  return [requestId, [response]];
}
